import { Flex, FlexProps } from '@modusign/design-system';

interface ContextMenuGroupProps extends FlexProps<'div'> {
  children: React.ReactNode;
}

export default function ContextMenuGroup({ children, ...props }: ContextMenuGroupProps) {
  return (
    <Flex {...props} flexDirection="column" gap="12px">
      {children}
    </Flex>
  );
}
